<template>
  <div v-if="users === null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0">
            <div class="row mb-2">
              <div class="col">
                <input
                  type="text"
                  class="form-control me-2"
                  placeholder="Buscar"
                  v-model="search"
                  @keyup="handleSearch"
                />
              </div>
              <div class="col-auto">
                <router-link
                  :to="{ name: 'Crear-Usuario' }"
                  class="
                    btn btn-primary
                    text-white
                    bg-blue-600
                    rounded-lg
                    hover:bg-blue-900
                    mb-0
                  "
                >
                  Nuevo responsable
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="
                        text-uppercase text-primary text-xs
                        font-weight-bolder
                        opacity-7
                      "
                    >
                      Nombre
                    </th>
                    <th
                      class="
                        text-uppercase text-primary text-xs
                        font-weight-bolder
                        opacity-7
                        ps-2
                      "
                    >
                      Apellido
                    </th>
                    <th
                      class="
                        text-uppercase text-primary text-xs
                        font-weight-bolder
                        opacity-7
                        ps-2
                      "
                    >
                      Email
                    </th>
                    <th class="text-custom opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in users" :key="item['id']">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">
                            {{ item["firstname"] }}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ item["lastname"] }}
                      </p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ item["email"] }}
                      </p>
                    </td>
                    <td class="text-center">
                      <router-link
                        :to="{
                          name: 'Actualizar-Usuario',
                          params: { id: item['id'] },
                        }"
                      >
                        <a
                          class="btn btn-link px-3 mb-0 text-primary"
                          href="javascript:;"
                        >
                          Editar
                        </a>
                      </router-link>
                      <span class="text-primary">|</span>
                      <a
                        class="btn btn-link px-3 mb-0 text-secondary"
                        href="javascript:;"
                        @click="handleDelete(item['id'])"
                      >
                        Borrar
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="float-end my-3 me-4">
              <el-pagination
                background
                v-model:currentPage="currentPage"
                v-model:page-size="pageSize"
                :total="totalItems"
                :page-sizes="[10, 15, 20, 30]"
                layout="sizes, prev, pager, next"
                @current-change="handleGetUsers"
                @size-change="handleGetUsers"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { ElMessageBox } from "element-plus";

export default {
  setup() {
    const store = useStore();
    const search = ref("");
    const currentPage = ref(1);
    const pageSize = ref(10);

    const getUsers = async (params = {}) => {
      const response = await store.dispatch("user/getUsers", params);
      return response;
    };

    onMounted(() => {
      handleGetUsers();
      store.dispatch("theme/setRouteParent", {});
      store.dispatch("theme/setNameCurrentElement", null);
    });

    const users = computed(() => store.getters["user/getUsers"]);
    const totalItems = computed(() => store.getters["user/getTotalItems"]);

    const handleSearch = () => {
      store.dispatch("user/getUsers", {
        rows: pageSize.value,
        _page: 1,
        firstname: search.value,
        lastname: search.value,
        email: search.value,
      });
    };

    const handleGetUsers = () => {
      getUsers({
        rows: pageSize.value,
        _page: currentPage.value,
        firstname: search.value,
        lastname: search.value,
        email: search.value,
      });
    };

    const deleteUser = async (user) => {
      try {
        await store.dispatch("user/deleteUser", user);
        handleGetUsers();
      } catch (error) {
        console.log(error);
      }
    };

    const handleDelete = (item) => {
      ElMessageBox.confirm("¿Estás seguro que deseas eliminar el usuario?")
        .then(() => {
          deleteUser(item);
        })
        .catch(() => {
          // catch error
        });
    };

    return {
      users,
      handleDelete,
      search,
      handleSearch,
      currentPage,
      pageSize,
      totalItems,
      handleGetUsers,
    };
  },
};
</script>
